import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        //查询公告列表
        querylogproject(context, payload) {
            return D.select({
                ...payload
            })
        },

        addlogproject(context, payload) {
            return D.select({
                ...payload
            })
        },

        querylogstore(context, payload) {
            return D.select({
                ...payload
            })
        },

        addlogstore(context, payload) {
            return D.select({
                ...payload
            })
        },

        querylogindex(context, payload) {
            return D.select({
                ...payload
            })
        },

        addlogindex(context, payload) {
            return D.select({
                ...payload
            })
        },

        deletelogindex(context, payload) {
            return D.del({
                ...payload
            })
        },
        querylog(context, payload) {
            return D.select({
                ...payload
            })
        },
        querylogsql(context, payload) {
            return D.select({
                ...payload
            })
        },
        addlogsql(context, payload) {
            return D.add({
                ...payload
            })
        },
        deletelogsql(context, payload) {
            return D.del({
                ...payload
            })
        },
        updatelogindex(context, payload) {
            return D.del({
                ...payload
            })
        },
        queryoverview(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryfolow(context, payload) {
            return D.select({
                ...payload
            })
        },
        updatefolow(context, payload) {
            return D.add({
                ...payload
            })
        },
        queryfolowsys(context, payload) {
            return D.select({
                ...payload
            })
        },
        addfolow(context, payload) {
            return D.add({
                ...payload
            })
        },
        deletefolow(context, payload) {
            return D.del({
                ...payload
            })
        },
        queryauthedappcodes(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryfolowsyserror(context, payload) {
            return D.select({
                ...payload
            })
        },
        queryhistorysys(context, payload) {
            return D.select({
                ...payload
            })
        },
        gethistorychart(context, payload) {
            return D.select({
                ...payload
            })
        },
        gethistorypie(context, payload) {
            return D.select({
                ...payload
            })
        },
        gethistoryurls(context, payload) {
            return D.select({
                ...payload
            })
        },
        getservicehistoryday(context, payload) {
            return D.select({
                ...payload
            })
        },
        getservicehistoryhour(context, payload) {
            return D.select({
                ...payload
            })
        },
        gethistorytable(context, payload) {
            return D.select({
                ...payload
            })
        },
        
    }
}